module.exports = __webpack_public_path__ + "static/media/feelingProudold.2936ce95.svg";